import packageJson from '../../package.json';

export const appContainerId = 'app';
export const appContainerSelector = `#${appContainerId}`;
export const appVersion = packageJson.version;
